import PropTypes from 'prop-types';
import React, { Component } from 'react'
import { DragSource } from 'react-dnd';
import BigCalendar from 'react-big-calendar'
import SnackbarContent from '@material-ui/core/SnackbarContent';
import { 
    IconButton, 
    Icon,
    Card,
    CardContent,
    Typography,
    Tooltip,
} from '@material-ui/core';

/* drag sources */
let eventSource = {
    beginDrag(props) {
        return Object.assign({},
            { event: props.event },
            { anchor: 'drop' }
        )
    }
}

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging()
    };
}

const propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,
    event: PropTypes.object.isRequired
}

class DraggableSidebarEvent extends Component {

    render() {
        let { connectDragSource, isDragging, event } = this.props;
        let EventWrapper = BigCalendar.components.eventWrapper;
        let title = event.title.length > 50 ? event.title.substring(0, 50) + '...' : event.title

        if (event.alreadySelected) {
            return (
                <EventWrapper event={event}>
                    <div style={{ width: '100%', opacity: isDragging ? 0.5 : 1 }}>
                        <Card
                            style={{
                                borderRadius: 4,
                                borderWidth: 2,
                                borderColor: event.Color,
                                backgroundColor: '#707070'
                            }}
                        >
                            <CardContent
                                style={{
                                    display:        'flex',
                                    justifyContent: 'space-between',
                                    alignItems:     'center',
                                    alignContent:   'center',
                                    padding:        '8px'
                                }}
                            >
                                <Typography>{event.title}</Typography>
                                <IconButton onClick={() => this.props.removeEventFromCalendar(event)} color="inherit" style={{ padding: '0' }}>
                                    <Icon>delete</Icon>
                                </IconButton>
                            </CardContent>
                        </Card>
                    </div>
                </EventWrapper>
            )
        }

        return (
            <EventWrapper event={event}>
                {connectDragSource(
                    <div style={{ width: '100%', opacity: isDragging ? 0.5 : 1 }}>
                        <Card
                            style={{
                                borderRadius: 4,
                                borderWidth: 2,
                                borderColor: event.Color,
                            }}
                        >
                            <CardContent
                                style={{
                                    display:        'flex',
                                    justifyContent: 'space-between',
                                    alignItems:     'center',
                                    alignContent:   'center',
                                    padding:        '8px'
                                }}
                            >
                                <Typography>{event.title}</Typography>
                                <Tooltip title={event.desc || ''}>
                                    <Icon>info</Icon>
                                </Tooltip>
                            </CardContent>
                        </Card>
                    </div>
                )}
            </EventWrapper>
        );
    }
}

DraggableSidebarEvent.propTypes = propTypes;


export default DragSource('event', eventSource, collectSource)(DraggableSidebarEvent);


// WEBPACK FOOTER //
// src/main/content/lesson/ScheduleComponents/EventChip.js